import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import AppSelector from './App';
import reportWebVitals from './reportWebVitals';
import LoginPage from './login/login';
import AdminDashboard from './admin/AdminDashboard';
import { AdminProvider } from './context/AdminContext';

const App = () => {
  return (
    <AdminProvider>
      <Router>
        <Routes>
          <Route path="/tic-bot" element={<AppSelector />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin-dashboard" element={<ChakraProvider resetCSS={false}><AdminDashboard /></ChakraProvider>} />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AdminProvider>
  )
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
